import { Teaser } from "./Teaser";
import { TeaserClient } from "./TeaserClient";
import { TrackingService } from "../../TrackingService";
import { TeaserService } from "./TeaserService";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";
import { onLoad } from "@otto-ec/global-resources/dom";

export function initTeaser() {
	const teaserService = new TeaserService(new TrackingService());
	onLoad.on(() => {
		const teaserContainer = document.getElementById("benefit_teaser");
		if (teaserContainer) {
			new Teaser(new TeaserClient(), teaserService, eventQBus).init(teaserContainer);
		}
	});
}

initTeaser();
